import axios from "axios";
import { URL_HOST } from "const/CommonConst";

import commonUtils from "utils/commonUtils"

const CURRENT_SERVICE = `${URL_HOST}ReporteAdministrativo`;

const ReporteAdministrativoService = {
  getTabla: async (codeClient, fechaInicio, fechaFin) => {
    try {
      if (!codeClient)
      {
        return [];
      }
      const result = await axios.get(
          `${CURRENT_SERVICE}/GetTabla?codeClient=${codeClient}&fechaInicio=${commonUtils.getDateForServer(fechaInicio)}&fechaFin=${commonUtils.getDateForServer(fechaFin)}`);
      return result.data;
    } catch (error) {
      console.error(error.message);

      throw error;
    }
  },
  getExcel: async (codeClient, fechaInicio, fechaFin) => {
    try {
      await axios.request({
        url: `${CURRENT_SERVICE}/GetExcel?codeClient=${codeClient}&fechaInicio=${commonUtils.getDateForServer(fechaInicio)}&fechaFin=${commonUtils.getDateForServer(fechaFin)}`,
        method: 'GET',
          responseType: 'blob', //important
        })
        .then(({ data }) => {          
          commonUtils.donwloadXlsxFromBlob(data, `ReporteAdministrativo_${codeClient}`);
            });
    } catch (error) {
      console.error(error.message);

      throw error;
    }
  }
};

export default ReporteAdministrativoService;
